import { createWrapper } from 'next-redux-wrapper';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import { IS_LOCAL_ENVIROMENT } from '~/src/constants';
import { makeSerializable } from '~/src/helpers/isr';
import { TState } from '~/src/store';

import rootReducer from './rootReducer';

const makeStore = (): Store<TState> => {
    const middlewareEnhancer = applyMiddleware(thunk);
    const composedEnhancers = IS_LOCAL_ENVIROMENT
        ? composeWithDevTools(middlewareEnhancer)
        : middlewareEnhancer;

    return createStore(rootReducer, composedEnhancers);
};

export const wrapper = createWrapper<Store<TState>>(makeStore, { debug: false });
export const isrWrapper = createWrapper<Store<TState>>(makeStore, {
    debug: false,
    serializeState: makeSerializable,
});
